module.exports = __webpack_public_path__ + "img/Meetings.b13f96c2.svg";